module.exports = __webpack_public_path__ + "img/family-room.c8eacf83.png";